/* Auto Generated */

export enum ContractProlongationOptionType {
	coterm = 1,
	extend = 2,
}
